import { useRouter } from 'next/router';
import { useRef, useState } from 'react';

import './InDepthCourse.scss';
import { BackButton } from '../index';
import icons from '../../shared/assets/icons/redesign';
import { srcSet, useDimensions } from '../../helpers/image';

const { Expert, PlayBoardered, Sleep, Handout } = icons;

export default function InDepthCourse({
  course,
  price,
  hasAccess,
  config,
  user
}) {
  const router = useRouter();
  const ref = useRef();
  const dimensions = useDimensions(ref);
  const [expandedDescription, setExpandedDescription] = useState(false);

  return (
    <div className="inDepthCourse">
      <BackButton />

      <div className="inDepthCourse-header">
        <h1 className="inDepthCourse-header-name">{course.displayName}</h1>

        <div className="inDepthCourse-header-author">
          <div ref={ref} className="inDepthCourse-header-author-img">
            {dimensions && (
              <img
                alt="course-author-image"
                srcSet={srcSet(course.userImageUrl, dimensions)}
              />
            )}
          </div>

          <span className="inDepthCourse-header-author-name">
            {course.username}
          </span>
        </div>

        {!hasAccess && (
          <>
            <button
              onClick={() =>
                router.push(
                  user.username
                    ? `/zwangerschapscursus/${course.name}/betalen`
                    : config.LOGIN_URL
                )
              }
              className="inDepthCourse-header-btn cursor-pointer"
            >
              Kopen - €{price || course.price}
            </button>

            <p className="inDepthCourse-header-description">
              {expandedDescription
                ? course.description
                : `${course.description.slice(0, 165)} ...`}
            </p>

            {!expandedDescription && (
              <button
                className="inDepthCourse-header-read-more-btn"
                onClick={() => setExpandedDescription(true)}
              >
                Read more
              </button>
            )}
          </>
        )}
      </div>

      {course.name === 'slaapcursus' && !hasAccess && (
        <ul className="inDepthCourse-feature-list">
          <li className="inDepthCourse-feature-list-item">
            <div className="inDepthCourse-feature-list-item-icon-wrap">
              <Expert />
            </div>
            <span className="inDepthCourse-feature-list-item-text">
              De Gentle Sleep Coach methode
            </span>
          </li>
          <li className="inDepthCourse-feature-list-item">
            <div className="inDepthCourse-feature-list-item-icon-wrap">
              <PlayBoardered className="inDepthCourse-feature-list-item-icon" />
            </div>
            <span className="inDepthCourse-feature-list-item-text">
              13 professioneel samengestelde video’s
            </span>
          </li>
          <li className="inDepthCourse-feature-list-item">
            <div className="inDepthCourse-feature-list-item-icon-wrap">
              <Sleep />
            </div>
            <span className="inDepthCourse-feature-list-item-text">
              Stel samen het slaap-plan op
            </span>
          </li>
          <li className="inDepthCourse-feature-list-item">
            <div className="inDepthCourse-feature-list-item-icon-wrap">
              <Handout />
            </div>
            <span className="inDepthCourse-feature-list-item-text">
              Gratis Hand-outs
            </span>
          </li>
        </ul>
      )}
    </div>
  );
}
